function toCurrencyFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"currency", currency:"USD", minimumFractionDigits:2, maximumFractionDigits: 2});
}

function toNumberFormat(snumber) {
    return parseFloat(snumber).toLocaleString("en-US", {style:"decimal", minimumFractionDigits:2, maximumFractionDigits: 2});
}
function setDefaultWizardStart(){
    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
     var wizardStart='';
    if(urlParams.has('sw') ){
       if(urlParams.get('sw') === 'd' ){
                window.wizardStart='StartWithDiamond';
                wizardStart='StartWithDiamond';
                localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));

        }
        else {
            window.wizardStart='StartWithSetting';
            wizardStart='StartWithSetting';
            localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
        }
    }
  else if(queryString.includes('?did')){
   window.wizardStart='StartWithDiamond';
     wizardStart='StartWithDiamond';
     localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
  }
    window.wizard.stepId=1; 
    return wizardStart;
}

function setWizardStepId(){
    let startWith = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardActualPage = sessionStorage.getItem('wizardActualPage');
    switch(wizardActualPage){
        case 'dyor-diamond-detail':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=1;
            }
            else {
                window.wizard.stepId=2;
            }
            break;
        case 'dyor-diamonds':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=1;
            }
            else {
                window.wizard.stepId=2;
            }
            break;
        case 'dyor-wizard-settings-collection':
            if(startWith == 'StartWithDiamond'){
                window.wizard.stepId=2;
            }
            else {
                window.wizard.stepId=1;
            }
            break;
        case 'dyor-wizard-completering':
                window.wizard.stepId=3;
            break;
        default:
            window.wizard.stepId=1;
            break;
    }
}

function getCaratDictionaryValueForWizard(carat){
    // get the integer part of the carat
    // Determine the lower bound
  let lowerBound = Math.floor(carat);
  let remainder = carat - lowerBound;
  let topNumber;
  if (remainder < 0.30) {
    topNumber = lowerBound + 0.29;
  } else if (remainder < 0.46) {
    topNumber = lowerBound + 0.45;
  } else {
    topNumber = lowerBound + 0.99;
  }

  // Increment the lower bound for the next range
  let increment = (lowerBound % 2 === 0) ? 0.46 : 0.53;
  if (carat > topNumber) {
    topNumber = lowerBound + increment + 0.99;
  }

  return 'dyo_carat_' + topNumber.toFixed(2).replace(".","-");
}

function changeWizardSelectionDiamond(type){
    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
    
    switch(type){
        case 'setting':
            var diamond_step = localStorage.getItem("complete_ring_step");
               if(diamond_step != null){
               localStorage.removeItem("complete_ring_step");
               }
            if(wizardInfo != null){
                wizardInfo.setting_product_name = null;
                wizardInfo.setting_variant_id = null;
                wizardInfo.setting_product_handle = null;
                wizardInfo.setting_image_url = null;
                wizardInfo.setting_variant_price = null;
                wizardInfo.setting_selected_shape = null;
                wizardInfo.setting_selected_side_carat_weight = null;
                wizardInfo.setting_variant_sku = null;
                wizardInfo.setting_max_carat_size = null;
                wizardInfo.setting_min_carat_size = null;
                wizardInfo.setting_selected_carat_size = null;
                wizardInfo.setting_selected_metal = null;
                wizardInfo.setting_allowed_shapes = null;
                wizardInfo.setting_allowed_ring_sizes = null;
                wizardInfo.setting_product_id = null;
                localStorage.setItem("wizardInfo", JSON.stringify(wizardInfo));
            }
            if(wizardInfo.stone_shape){            
                let caractDictValue = getCaratDictionaryValueForWizard(wizardInfo.stone_carat);
                if(wizardInfo.stone_shape.toLowerCase().includes('cushion')){
                    wizardInfo.stone_shape = 'Cushion';
                }
                let shapeDictValue = 'dyo_shape_'+wizardInfo.stone_shape.toLowerCase();
                window.location.href = '/collections/engagement-ring-settings-shape/'+caractDictValue+'+'+shapeDictValue;
            }
            else {
                // No stone selected neither Setting, we need to remove all the info from the wizard because it is empty
                window.localStorage.removeItem('wizardInfo');
                window.localStorage.removeItem('wizardSessionDate');
                window.localStorage.removeItem('latestSearch');

                window.location.href = '/collections/engagement-ring-settings-shape?sw=s';
            }
                
            break;
        case 'diamond':
            var diamond_step = localStorage.getItem("diamond_page_step");
             if(diamond_step != null){
             localStorage.removeItem("diamond_page_step");
             }
            if(wizardInfo.setting_allowed_shapes != null){
               localStorage.setItem("setting_allowed_shapes",wizardInfo.setting_allowed_shapes);
               //wizardInfo.setting_allowed_shapes = []
             }
            if(wizardInfo.setting_max_carat_size != null && wizardInfo.setting_min_carat_size != null){
               localStorage.setItem("setting_max_carat_size",wizardInfo.setting_max_carat_size);
              localStorage.setItem("setting_min_carat_size",wizardInfo.setting_min_carat_size);
               // wizardInfo.setting_max_carat_size = 11.58;
               // wizardInfo.setting_min_carat_size = 0.25;
             
             }
            if(wizardInfo != null){
                wizardInfo.stone_shape = null;
                wizardInfo.stone_carat = null;
                wizardInfo.stone_price = null;
                wizardInfo.stone_image_url = null;
                wizardInfo.stone_clarity = null;
                wizardInfo.stone_color = null;
                wizardInfo.stone_cut = null;
                wizardInfo.stone_delivery = null;
                wizardInfo.stone_id = null;
                wizardInfo.stone_image_url = null;
                localStorage.setItem("wizardInfo", JSON.stringify(wizardInfo));
            }
            if(!wizardInfo.setting_variant_id || wizardInfo.setting_variant_id == 0){

                //There's no setting selected so we should clear the LocalStorage because the user is restarting the wizard
                window.localStorage.removeItem('wizardInfo');
                window.localStorage.removeItem('wizardSessionDate');
                window.localStorage.removeItem('latestSearch');
                window.location.href = '/pages/dyor-diamonds?sw=d';
            }
            else {
              window.location.href = '/pages/dyor-diamonds?sw=d';
            }
            break;
    }
}
function loadWizard(){   
    let screenWidth = screen.width;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.removeItem('wizardInfo_gemstone');
            localStorage.removeItem('gemstone_template');
            localStorage.removeItem('wizardInfo_gemstone');
            localStorage.removeItem('metal_gemstone');
            localStorage.removeItem('gemstone_shape');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
          
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('wizardInfo');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.removeItem('wizardInfo_gemstone');
        localStorage.removeItem('gemstone_template');
        localStorage.removeItem('wizardInfo_gemstone');
        localStorage.removeItem('metal_gemstone');
        localStorage.removeItem('gemstone_shape');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    // Let's do some validations
    // Is wizardStart null? If so, let's set it to default
    if (wizardStart == null || wizardStart == '' || wizardStart == 'undefined') {
       wizardStart = setDefaultWizardStart();
    }
    else {
        // If start with setting we need to check that we have a setting selected
        if (wizardStart == 'StartWithSetting') {
            let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
            if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                wizardStart = setDefaultWizardStart();   
            }
            else {
                if (wizardInfo.setting_product_name == null || wizardInfo.setting_product_name == '' || wizardInfo.setting_product_name == 'undefined') {
                    //Let's check if there's a diamond, if there's a diamond then we have to change the startWith to diamond
                    if (wizardInfo.stone_shape != null && wizardInfo.stone_shape != '' && wizardInfo.stone_shape != 'undefined') {
                        window.wizardStart='StartWithDiamond';
                        wizardStart='StartWithDiamond';
                        localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
                        
             
                    }
                }
            }
        }
        else {
            // If start with diamond we need to check that we have a diamond selected
            if (wizardStart == 'StartWithDiamond') {
                let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
                if (wizardInfo == null || wizardInfo == '' || wizardInfo == 'undefined') {
                    wizardStart = setDefaultWizardStart();   
                }
                else {
                    if (wizardInfo.stone_shape == null || wizardInfo.stone_shape == '' || wizardInfo.stone_shape == 'undefined') {
                        //Let's check if there's a setting, if there's a setting then we have to change the startWith to setting
                        if (wizardInfo.setting_product_name != null && wizardInfo.setting_product_name != '' && wizardInfo.setting_product_name != 'undefined') {
                            window.wizardStart='StartWithSetting';
                            wizardStart='StartWithSetting';
                            localStorage.setItem("wizardStart", JSON.stringify(window.wizardStart));
                                
                        }
                    }
                }
            }
        }
        setWizardStepId();

    }

    let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo'));
    if (screenWidth >= 800) {
        let step3
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;

            case 'StartWithDiamond':                
                loadDesktopStartWithDiamondWizard();
                break;

            default:
                break;
        }

    } else {
        loadMobileWizard();
        
    }
}

function loadDesktopStartWithSettingWizard(){
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
  
    let wizardInfo;
    wizardInfo = localStorage.getItem('wizardInfo'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
        price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100));  
        priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate );
    }
    else {
        wizardInfo = window.wizard;
    }
  if(wizardInfo != null){
    let stone_image_url = wizardInfo.stone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (window.wizard.stepId) {
        case 1:
            console.log('case 55');
            //console.log("Over here, wizardInfo", wizardInfo);
            // Let's validate if we have any selections in localStorage, if not, let's present the default
             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2; 
            let step1 =  document.querySelector(".diamond_wizard #step1");
            step1.classList.add('step-select');
            stepPrev =  document.querySelector(".diamond_wizard #step0");
            stepPrev.classList.add('step-border');
          
            if(wizardInfo == null){    
               
                /**Step 1 selected */
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Setting`;
                // document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #info-wizard-step-1').style.display="none";               
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                /**Step 2 NO selected */
                // document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-1-noSelected');
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Diamonds`;
                 document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Diamonds</a>`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
                /**Step 3 NO selected */
                // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                // document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;
            }
            else {
                if(wizardInfo.setting_product_name){
                    settingSelected = true;
                     document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
                     document.querySelector(".diamond_wizard #nro-2").innerHTML=2; 
                    /**Step 1 selected */
                 
                     document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                     document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
                     document.querySelector('.diamond_wizard #info-wizard-step-1-2').innerHTML= `${price} `; 
                     document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
                     document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
                     document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected');
                    // document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                else {
                  
                    /**Step 1 selected */
                  
                     document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Setting`;
                    // document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                     document.querySelector('.diamond_wizard #info-wizard-step-1').style.display="none";               
                     document.querySelector('.diamond_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                     document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
                }
                if(wizardInfo.stone_shape){
                    stoneSelected = true;
                    /**Step 2 selected */
                   /**Step 2 NO selected */
                     document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-selected');
                     document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose ${wizardInfo.setting_stone_type}`;           
                     document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML = `${parseFloat(wizardInfo.stone_carat).toFixed(2)} ${wizardInfo.stone_shape} - ${priceStone}`;                
                     document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
                     document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
                     document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
                }
                else {
                    // document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                     document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                     document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-1-noSelected');
                     document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Diamonds`;
                     document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
                }
                if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                    // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                     document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-ring">Select Ring Size</a>`;
                }
                 /**Step 3 NO selected */
                 else {
                    // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                     document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;
                 }
                
            }
            break;
        case 2:
        console.log('case 56');
             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2;                                 
            let step2 =  document.querySelector(".diamond_wizard #step2");
            step2.classList.add('step-select');
            stepPrev =  document.querySelector(".diamond_wizard #step1");
            stepPrev.classList.add('step-border');
            document.querySelector('.diamond_wizard #title-1-step1').style.display="none"; 
             document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
             document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
             document.querySelector('.diamond_wizard #info-wizard-step-1-2').innerHTML= `${price} `; 
             document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
             document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
             document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected');

            if(wizardInfo.stone_shape){
                 document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose ${wizardInfo.setting_stone_type}`;           
                 document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML = `${parseFloat(wizardInfo.stone_carat).toFixed(2)} ${wizardInfo.stone_shape} - ${priceStone}`;               
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
                 document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
            }
            else {
                // document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose ${wizardInfo.setting_stone_type}`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected'); 
            }
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-ring">Select Ring Size</a>`;
            }
            else {
                // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                // document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;
    
            }
            /**Step 3 NO selected */
          
            break;
        case 3:       
       console.log('case 57');
             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2;       
            step3 =  document.querySelector(".diamond_wizard #step3");
            step3.classList.add('step-select-3');                
            /**Step 1 NO selected */
             document.querySelector('.diamond_wizard #title-1-step1').style.display="none"; 
             document.querySelector('.diamond_wizard #title-1-step2').style.display="none"; 
             document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
             document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML= `${wizardInfo.setting_product_name} `; 
             document.querySelector('.diamond_wizard #info-wizard-step-1-2').innerHTML= `${price} `; 
             document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
             document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.setting_image_url}`;
             document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected');
            /**Step 2 NO selected */
             document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-selected');
             document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose ${wizardInfo.setting_stone_type}`;           
             document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML = wizardInfo.stone_carat+' '+wizardInfo.stone_shape+'- '+priceStone;              
             document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.stone_image_url}`;
             document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
             document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
           /**Step 3  selected */
            // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
             document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;
            

            break;
        default:
            break;
    }
    
}

function loadDesktopStartWithDiamondWizard(){
    let wizardInfo;
    let currentCurrency = Shopify.currency.active;
    let currentCurrencySymbol = $('body').attr('data-currency');
    let currentRate = window.Shopify.currency.rate;
    wizardInfo = localStorage.getItem('wizardInfo'); 
    let wizardStart;
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo);   
         price = currentCurrencySymbol+' '+toNumberFormat((wizardInfo.setting_variant_price/100)); 
         priceStone = currentCurrencySymbol+' '+toNumberFormat(wizardInfo.stone_price * currentRate );
    }
    else {
        wizardInfo = window.wizard;
    }
    if(wizardInfo != null){
    let stone_image_url = wizardInfo.stone_image_url;
     if(stone_image_url != null ){
    $('.banner_size_images').find('.banner_size_each img').attr('src',stone_image_url);
    }
  }
    switch (window.wizard.stepId) {
        case 1:
            console.log('case 1')
         
             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2;  
            let step1 =  document.querySelector(".diamond_wizard #step1");
            step1.classList.add('step-select');
            stepPrev =  document.querySelector(".diamond_wizard #step0");
            stepPrev.classList.add('step-border');
            if(wizardInfo.stone_shape){
              
                 document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;           
                 document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML = `${parseFloat(wizardInfo.stone_carat).toFixed(2)} ${wizardInfo.stone_shape} - ${toCurrencyFormat(wizardInfo.stone_price)}`;               
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                // if the user is in diamond-detail page, we need to show the link to go back to diamond list page
                let step1Links = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View</a>`;
                if (window.location.href.indexOf("diamond-detail") > -1) {
                    step1Links += ` / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;
                }
                 document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = step1Links;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
            }
            else {
                
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;
                // document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #info-wizard-step-2').style.display="none";               
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond');
                
            }            
            /**Step 2 NO selected RING */
            if(wizardInfo.setting_product_name){
            
               document.querySelector('.diamond_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
               document.querySelector('.diamond_wizard #title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
               document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML= `${price} `;
               document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
               document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
               document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
            }
            else {
               
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Setting`;
                 document.querySelector('.diamond_wizard #info-wizard-step-2').style.display="none";               
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                 document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-ring">Select Ring Size</a>`;
            }
            else {
            }
           
            
            break;
        case 2:
            console.log('case 2');

             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2;  
            let step2 =  document.querySelector(".diamond_wizard #step2");
            step2.classList.add('step-select');
            stepPrev =  document.querySelector(".diamond_wizard #step1");
            stepPrev.classList.add('step-border');

            if(wizardInfo.stone_shape){
               document.querySelector('.diamond_wizard #title-1-step1').style.display="none";   
                 document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;           
                 document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML = `${parseFloat(wizardInfo.stone_carat).toFixed(2)} ${wizardInfo.stone_shape} - ${priceStone}`;               
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
                 document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
            }
            else {
              document.querySelector('.diamond_wizard #title-1-step1').style.display="none"; 
                // document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_name){
               
                 document.querySelector('.diamond_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
                 document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML= `${price} `; 
                 document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
            }
            else {
              let pd_title = $('.product__info-wrapper .product__title.mb_6.small-hide h1').text();
              let main_price =  $('.product__info-container .price-item--regular').text();
              if(pd_title != ''){
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = pd_title;
              }else{
                  document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Setting`;
              }
                // document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
              if(main_price != ''){
                 document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML = main_price; 
                 document.querySelector('.diamond_wizard #info-wizard-step-2').style.display="block";
              }else{
                   document.querySelector('.diamond_wizard #info-wizard-step-2').style.display="none";
              }
              if(pd_title != '' && main_price != ''){
               document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')">Change</a>`;
            }
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
        
            /**Step 3 NO selected */
            if(wizardInfo.setting_variant_id && wizardInfo.stone_shape){
                // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="/pages/complete-ring">Select Ring Size</a>`;
            }
            else {
                // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');

            }
            break;                
        case 3:
            console.log('case 3');
             document.querySelector(".diamond_wizard #nro-1").innerHTML=1;
             document.querySelector(".diamond_wizard #nro-2").innerHTML=2;  

            step3 =  document.querySelector(".diamond_wizard #step3");
            step3.classList.add('step-select-3');
            stepPrev =  document.querySelector(".diamond_wizard #step2");
            stepPrev.classList.add('step-border');

           if(wizardInfo.stone_shape){
                /**Step 2 selected */
               /**Step 2 NO selected */
              document.querySelector('.diamond_wizard #title-1-step1').style.display="none"; 
                 document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;           
                 document.querySelector('.diamond_wizard #info-wizard-step-1').innerHTML = `${parseFloat(wizardInfo.stone_carat).toFixed(2)} ${wizardInfo.stone_shape} - ${toCurrencyFormat(wizardInfo.stone_price)}`;               
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`${wizardInfo.stone_image_url}`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-selected-diamond');
                 document.querySelector('.diamond_wizard #subtitle-1-step1').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
            }
            else {
                // document.querySelector('.diamond_wizard #col-step-1').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #title-1-step1').innerHTML = `Choose Diamonds`;
                // document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = ` <a class="title-step title-middle" href="/pages/dyor-diamonds">Browse Diamonds</a>`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-diamond.png?v=1699447012`;
                 document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected-diamond'); 
            }

            if(wizardInfo.setting_product_name){
                // document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Setting`;
                 document.querySelector('.diamond_wizard #title-1-step2').classList.add('col-wizard-margin-selected');
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML= `${wizardInfo.setting_product_name} `; 
                 document.querySelector('.diamond_wizard #info-wizard-step-2').innerHTML= `${price} `; 
                 document.querySelector('.diamond_wizard #subtitle-1-step2').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`${wizardInfo.setting_image_url}`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-selected');
                // document.querySelector('.diamond_wizard #img-wizard-step1').classList.add('img-step-1-noSelected');
            }
            else {
                /**Step 2 selected */
                 document.querySelector('.diamond_wizard #title-1-step2').innerHTML = `Choose Setting`;
                // document.querySelector('.diamond_wizard #col-step-2').classList.add('col-wizard-margin-Noselected');
                 document.querySelector('.diamond_wizard #info-wizard-step-2').style.display="none";               
                 document.querySelector('.diamond_wizard #img-wizard-step2').src=`https://cdn.shopify.com/s/files/1/0576/3350/5416/files/wizard-ring.png?v=1699458491`;
                 document.querySelector('.diamond_wizard #img-wizard-step2').classList.add('img-step-2-noSelected');
            }
            /**Step 3 NO selected */
            // document.querySelector('.diamond_wizard #col-step-3').classList.add('col-wizard-margin-Noselected');
             document.querySelector('.diamond_wizard #subtitle-1-step3').innerHTML = ` <a class="title-step title-middle" href="">Select Ring Size</a>`;

            break;
        default:
            break;
    }            


}

function loadMobileWizard(){
    let wizardSessionDate = JSON.parse(localStorage.getItem('wizardSessionDate'));
    if(wizardSessionDate){
        // let's parse the date
        let date = new Date(wizardSessionDate);
        //if more than 4 hours have passed let's clear the wizard/localStorage and all that stuff
        if((new Date() - date) > 14400000){
            localStorage.removeItem('wizardInfo');
            localStorage.removeItem('wizardStart');
            localStorage.removeItem('wizardSessionDate');
            localStorage.removeItem('latestSearch');
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
        else {
            localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));
        }
    }
    else {
        // Not even a date, let's clear the localStorage
        localStorage.removeItem('wizardInfo');
        localStorage.removeItem('wizardStart');
        localStorage.removeItem('wizardSessionDate');
        localStorage.removeItem('latestSearch');
        localStorage.setItem("wizardSessionDate", JSON.stringify(new Date()));

    }
    let step1, stp2, step3;
    let choose1, choose2, choose3;
    let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));

let wizardInfo;
    wizardInfo = localStorage.getItem('wizardInfo'); 
    wizardStart= JSON.parse(localStorage.getItem('wizardStart'));
    let price;
    let priceStone;
    let settingSelected = false;
    let stoneSelected = false;
    
    if (wizardInfo != null) {
        wizardInfo = JSON.parse(wizardInfo); 
        price = toCurrencyFormat(wizardInfo.setting_variant_price/100);  
        priceStone = toCurrencyFormat(wizardInfo.stone_price);
    }
    else {
        wizardInfo = window.wizard;
    }
    if(wizardStart == 'StartWithDiamond'){
    switch (window.wizard.stepId) {
        
        case 1:
         console.log('case 11');
        if(wizardInfo.stone_shape){  
                   document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting :`;
                     document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
                }else{
                  document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting :`;
                }
              if(wizardInfo.setting_product_name){
                    settingSelected = true;
                     /**Step 1 selected */
                      document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                     document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
                }else{
                  document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                }
            break;
        case 2:
         console.log('case 12');
     if(wizardInfo.stone_shape){  
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
            }
            else {
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_name){
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Diamonds:`;
               document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
             }else {
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Diamonds:`;  
                   document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3: 
         console.log('case 13');
            /**Step 1 NO selected */
         if(wizardInfo.stone_shape){  
               document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
            document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
         }
             document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    }
    }else{
      switch (window.wizard.stepId) {
        case 1:
           console.log('case 14');
               if(wizardInfo.stone_shape){  
                   document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                     document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
                }else{
                 
                }
              if(wizardInfo.setting_product_name){
                    settingSelected = true;
                     /**Step 1 selected */
                      document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                     document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
                }
            break;
        case 2:
          console.log('case 15');
        if(wizardInfo.stone_shape){  
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
                document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
            }
            else {
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                     document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
               document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML =`To Be Selected`
            }
           if(wizardInfo.setting_product_name){
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Diamonds:`;
               document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                       
             }else {
                document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose Setting :`;  
                   document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Diamonds:`;
               document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML =`To Be Selected`
            }
            /**Step 3 NO selected */
          
            break;
        case 3:
          console.log('case 16');
            /**Step 1 NO selected */
         if(wizardInfo.stone_shape){  
               document.querySelector('.diamond_wizard #title-1-step1_mob').innerHTML = `Choose  Diamonds :`;  
                 document.querySelector('.diamond_wizard #title-1-step2_mob').innerHTML = `Choose Setting:`;
            document.querySelector('.diamond_wizard #subtitle-1-step1_mob').innerHTML = `<a class="title-step title-middle" href="/pages/diamond-detail?did=${wizardInfo.stone_id}">View /</a><a class="title-step title-middle" onclick="changeWizardSelectionDiamond('diamond')">Change</a>`;;
         }
             document.querySelector('.diamond_wizard #subtitle-1-step2_mob').innerHTML = `<a class="title-step title-middle" href="/products/${wizardInfo.setting_product_handle}">View</a> / <a class="title-step title-middle" onclick="changeWizardSelectionDiamond('setting')"> Change</a>`;                              
            
           /**Step 3  selected */
            break;
        default:
            break;
    }
    }
}
loadWizard();
$(document).ready(function(){
$(window).on("load resize",function(){
    let screenWidth = screen.width;
    wizardStart = JSON.parse(localStorage.getItem('wizardStart'));  
    if (screenWidth >= 800) {
        switch (wizardStart) {
            case 'StartWithSetting':        
                loadDesktopStartWithSettingWizard();
                break;
            case 'StartWithDiamond':
          var wizardInfo;
              wizardInfo = localStorage.getItem('wizardInfo'); 
              loadDesktopStartWithDiamondWizard();
                break;
            default:
                break;
        }
    } else {
        loadMobileWizard();
        }
});
  });

